import { IRadioOption } from 'app/interfaces/IRadioOption';

export enum valueType {
   actual = 'actual',
   display = 'display'

}

export const valueTypeOptions: Array<IRadioOption<valueType>> = [
    {
        label: stringResources.ServiceNowActualValueTypeLabel,
        value: valueType.actual
    },
    {
        label: stringResources.ServiceNowDisplayValueTypeLabel,
        value: valueType.display
    }
];

